import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, ModalController, NavController, PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AccountPaymentFavoriteDTO, AccountPaymentFavoriteService, TypeEnum } from '@wlp/ui-bs-account-payment-favorite';
import { DataAccountResponse, TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import { of } from 'rxjs/internal/observable/of';
import { catchError, retry, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { PopoverFavoritesComponent } from 'src/app/views/themes/sentinel/modals/popover-favorites/popover-favorites.component';

import { FavoritesDataFilterPipe } from '../../favorites-data-filter.pipe';
import { ModalAlertComponent } from './../../../../../../modals/modal-alert/modal-alert.component';

@Component({
  selector: 'ui-t-transfer-document',
  templateUrl: './transfer-document.page.html',
  styleUrls: ['./transfer-document.page.scss'],
  providers: [FavoritesDataFilterPipe],
})
export class TransferDocumentPage implements OnInit {
  public formTransfer: FormGroup;
  public errorMessages: any;
  public transferOnUs = false;
  public responseTransfer: any;
  public switchFavorites: any = 'new';
  public transferData: any;
  public favorites: any;
  userProfile: UserInfoProfile;
  @Output() transferType = new EventEmitter();
  selectedFavorite: boolean;
  toogleFavorite: any;
  realm: any;

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    private transferService: TransferService,
    private navCtrl: NavController,
    public alertController: AlertController,
    protected userInfoService: UserInfoService,
    public popoverController: PopoverController,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private loadingService: LoadingService,
    private modalController: ModalController,
    public pipeFilter: FavoritesDataFilterPipe,
    private storage: Storage,
    public router: Router,
    private translate: UiBsTranslateService,
    private layoutConfigService: LayoutConfigService,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    /* this.realm = this.accountPaymentFavoriteService.realmValidation(environment.wlThemeParameterization.wlTheme.realm.toUpperCase()); */
    this.realm = true;
    this.errorMessages = this.transferService.getFormMessageError();
    this.formTransfer = this.transferService.createFormTransfer();
    this.loadUser();
  }

  public ionViewWillEnter() {
    this.transferService.setTransferFlow('On-Us');
  }

  public async ngOnDestroy() {
    this.formTransfer = null;
    this.transferData = null;
  }

  private loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
        if (this.userProfile) {
          this.getAllFavorites();
        }
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  public formIsValid() {
    if (this.formTransfer.controls.document.status === 'VALID') {
      return true;
    } else {
      return false;
    }
  }

  public async continue() {
    const data = this.formTransfer.getRawValue();
    this.transferService
      .checkAccountSameBucket(this.userProfile.uuidWhiteLabel, data.document, this.userProfile.uuidAccount)
      .then((res) => {
        if (res && res.length > 0) {
          this.transferData = res;
          this.transferOnUs = true;
          return;
        } else {
          this.transferOnUs = false;
          this.accountNotFound();
          this.formTransfer.controls.typeTransfer.setValue('TED');
          this.transferService.setTransfer(this.formTransfer);
          return;
        }
      })
      .catch((err) => this.transferService.getErrorTransfer(err));
  }

  private async accountNotFound() {
    this.statusTransaction(
      'warning-circle',
      'CASH_OUT.TRANSFER_TED.MESSAGES.SUBHEADER_1',
      'CASH_OUT.TRANSFER_TED.MESSAGES.MESSAGE_1'
    );
  }

  /*   private async sameAccountError() {
      this.statusTransaction('warning-circle', 'CASH_OUT.TRANSFER_TED.MESSAGES.SUBHEADER_2', 'CASH_OUT.TRANSFER_TED.MESSAGES.MESSAGE_2');
    } */

  /*   private loadData(accountsFound: any) {
      if (accountsFound.bankAccount === this.userProfile.numberAccountBank && accountsFound.bankBranch === this.userProfile.agencyBank) {
        this.sameAccountError();
      } else {
        this.transferService.getTransfer().subscribe((res: TransferResponse) => {
          this.transferData = res;
          this.transferOnUs = true;
        });
        this.formTransfer = this.transferService.getFormTransfer();
      }
    } */

  public onUsTransfer(account) {
    this.transferService.mountTransfer(account, this.formTransfer.get('document').value);
    this.saveFavorite(this.toogleFavorite);
    this.navCtrl.navigateRoot('app/charging/transfer/on-us-favorites');
  }

  public segmentChanged(favorite) {
    this.getAllFavorites();
    this.switchFavorites = favorite;
  }

  public optionsFavorites(favorite: any) {
    // this.formTransfer.controls.document.setValue(favorite.document);
    console.log("**********************")
    this.selectedFavorite = true;
    this.switchFavorites = 'new';

    this.formTransfer.setValue({
      document: favorite.document,
      name: favorite.name,
      accountType: favorite.typeAccount === 'CC' ? 'CC' : 'PP',
      bank: favorite.bankName,
      branch: favorite.agencyNumber,
      accountNumber: favorite.accountNumber,
      bankCode: favorite.codeBank ? favorite.codeBank : '',
      transferValue: '',
      dateSchedule: null,
      scheduled: false,
      uuidWhiteLabelDestination: favorite.uuidWhiteLabelDestination,
      uuidAccountPaymentDestination: favorite.uuidAccountPaymentDestination,
      typeTransfer: favorite.type === 'TED' ? 'TED' : 'On-Us',
    });
    this.transferService.setTransfer(this.formTransfer);

    const favoriteBody: DataAccountResponse = {
      bankAccount: favorite.accountNumber,
      bankBranch: favorite.agencyNumber,
      bankName: favorite.bankName,
      codeBank: favorite.codeBank,
      document: favorite.document,
      name: favorite.name,
      uuidAccountPayment: favorite.uuidAccountPaymentDestination,
      uuidWhiteLabel: favorite.uuidWhiteLabelDestination,
      transferValue: '',
    };
    this.transferService.mountTransfer(favoriteBody, this.formTransfer.get('document').value);
    this.transferService.setSavedFavorite(true);
    this.navCtrl.navigateRoot('app/charging/transfer/on-us-favorites');
  }

  public async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverFavoritesComponent,
      cssClass: 'popover-class',
      event: ev.event,
      translucent: true,
      mode: 'md',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data == 'exclude') {
        this.deleteFavorite(ev.favorite);
      }
      if (data.data == 'edit') {
        this.storage.set('favoriteForEdit', ev.favorite).then(() => {
          this.storage.set('favoriteType', 'ON-US');
          this.switchFavorites = 'new';
          this.router.navigate(['/app/charging/favorites/transfer']);
        });
      }
    });
    return await popover.present();
  }

  public filterReceipt(value) {
    if (value !== '') {
      this.favorites = this.pipeFilter.transform(this.responseTransfer, value);
      return;
    } else {
    }
  }

  private getAllFavorites() {
    this.accountPaymentFavoriteService
      .getAllFavoritesType(this.userProfile.uuidWhiteLabel, this.userProfile.uuidAccount, TypeEnum.ON_US)
      .pipe(
        tap((data) => { 
          this.responseTransfer = data;
          this.favorites = data;
          this.cdr.detectChanges();
          // this.favorites = this.accountPaymentFavoriteService.orderListFavoritesByName(this.favorites);
        }),
        retry(2),
        catchError((_) => {
          return of(null);
        })
      )
      .subscribe();
  }

  private saveFavorite(checked) {
    if (checked) {
      // this.loadingService.show();
      let prepare: AccountPaymentFavoriteDTO;
      prepare = {
        uuidWhiteLabel: this.userProfile.uuidWhiteLabel,
        uuidAccountPayment: this.userProfile.uuidAccount,
        name: this.transferData.name,
        document: this.transferData.document,
        codeBank: this.transferData.bankCode,
        bankName: this.transferData.bank,
        accountNumber: this.transferData.accountNumber,
        agencyNumber: this.transferData.branch,
        typeAccount: this.transferData.accountType,
        zipCode: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        uuid: '',
        type: TypeEnum.ON_US,
      };
      this.accountPaymentFavoriteService
        .saveFavorite(prepare)
        .pipe(
          tap((data) => {
            if (data.status) {
              // this.statusTransaction('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES', true);
            } else {
              // this.statusTransaction('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', true);
              // this.toogleFavorite = false;
            }
            // this.loadingService.hide();
          }),
          catchError((_) => {
            // this.loadingService.hide();
            return of(null);
          })
        )
        .subscribe();
    }
  }

  private async statusTransaction(status: string, message: string, description?: string, confirmation?: boolean) {
    this.loadingService.hide();

    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status: status,
        message: message,
        description: description,
        confirmBtn: 'CASH_OUT.TRANSFER_ON_US.CLOSE',
        confirmation: confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });
    modalSuccess.onDidDismiss().then((data) => {});
    return await modalSuccess.present();
  }

  private deleteFavorite(favorite) {
    this.loadingService.show();
    this.accountPaymentFavoriteService
      .deleteFavorite(favorite)
      .pipe(
        tap((data) => {
          if (data.status) {
            // this.statusTransaction('success', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.SUCCESS_FAVORITES_EXCLUDE', true);
            this.getAllFavorites();
          } else {
            // this.statusTransaction('failed', 'CASH_OUT.TRANSFER_ON_US.MESSAGES.FAILED_FAVORITES', true);
          }
          this.loadingService.hide();
        }),
        catchError((_) => {
          this.loadingService.hide();
          return of(null);
        })
      )
      .subscribe();
  }

  private checkListAccount(account) {
    return account.codeBank.length >= 1 && account.accountNumber.length >= 1 && account.agencyNumber.length >= 1;
  }
}
